import React, { useState } from 'react';
import { Box, BottomNavigation, BottomNavigationAction, useTheme } from '@mui/material';
import { Info, History, WhatsApp } from '@mui/icons-material';
import { useTranslation } from 'react-i18next';
import { useWhatsappClient } from '@frontend/features/whatsapp/components/WhatsappClientContext';
import { CaseSidebar } from './CaseSidebar';
import { CaseContentHistory } from './CaseContentHistory';
import { useCaseContext } from '../context';

export const CaseViewMobile = () => {
  const [activeTab, setActiveTab] = useState(0);
  const theme = useTheme();
  const { t } = useTranslation();
  const { openWhatsapp } = useWhatsappClient();
  const {
    caseData,
    onEditCaseName,
    onCopyCaseNumber,
    onChangeStatus,
    onChangeWorkflow,
    onChangeIAEnabled,
    onChangeStep,
    onStepInstructionsOpen,
    onClientSelectorOpen,
    onOrganizationEditOpen,
    onAgencyEditOpen,
    onTeamSelectorOpen,
    onAgentSelectorOpen,
    onAssignToMe,
    onSaveLegacySaleOrder,
    onSaveLegacyReference,
    onRemoveRelation,
    onLinkCaseOpen,
  } = useCaseContext();

  // Suppress unused variable warnings - props are for future use or interface consistency
  // void caseData;

  const handleTabChange = (_event: React.SyntheticEvent, newValue: number) => {
    // WhatsApp button (index 2) is an action, not a tab
    if (newValue === 2) {
      if (caseData?.clientWhatsappNumber && caseData?.clientId) {
        openWhatsapp(caseData.clientId);
      }
      return;
    }

    setActiveTab(newValue);
  };

  return (
    <Box
      sx={{
        // no se pq mierda pero ese 130px funciona para que el bottom nav no tape el contenido
        height: 'calc(100vh - 130px)',
        display: 'flex',
        flexDirection: 'column',
        backgroundColor: theme.palette.background.default,
      }}
    >
      {/* Contenido principal */}
      <Box
        flex={1}
        overflow="auto"
        pb={8} // Espacio para el bottom nav
      >
        {activeTab === 0 && (
          <CaseSidebar
            isMobile={true}
            onEditCaseName={onEditCaseName}
            onCopyCaseNumber={onCopyCaseNumber}
            onChangeStatus={onChangeStatus}
            onChangeWorkflow={onChangeWorkflow}
            onChangeIAEnabled={onChangeIAEnabled}
            onChangeStep={onChangeStep}
            onStepInstructionsOpen={onStepInstructionsOpen}
            onClientSelectorOpen={onClientSelectorOpen}
            onOrganizationEditOpen={onOrganizationEditOpen}
            onAgencyEditOpen={onAgencyEditOpen}
            onTeamSelectorOpen={onTeamSelectorOpen}
            onAgentSelectorOpen={onAgentSelectorOpen}
            onAssignToMe={onAssignToMe}
            onSaveLegacySaleOrder={onSaveLegacySaleOrder}
            onSaveLegacyReference={onSaveLegacyReference}
            onRemoveRelation={onRemoveRelation}
            onLinkCaseOpen={onLinkCaseOpen}
          />
        )}

        {activeTab === 1 && <CaseContentHistory channel={null} isMobile={true} />}
      </Box>

      {/* Bottom Navigation */}
      <BottomNavigation
        value={activeTab}
        onChange={handleTabChange}
        showLabels
        sx={{
          position: 'fixed',
          bottom: 0,
          left: 0,
          right: 0,
          borderTop: `1px solid ${theme.palette.divider}`,
          zIndex: 1000,
          height: 64,
          backgroundColor: theme.palette.background.paper,
          '& .MuiBottomNavigationAction-root': {
            minWidth: 'auto',
            padding: '6px 12px 8px',
            '&.Mui-selected': {
              color: theme.palette.primary.main,
            },
          },
          '& .MuiBottomNavigationAction-label': {
            fontSize: '0.75rem',
            '&.Mui-selected': {
              fontSize: '0.75rem',
            },
          },
        }}
      >
        <BottomNavigationAction label={t('cases.view.tabInfo')} icon={<Info />} />
        <BottomNavigationAction label={t('cases.view.tabHistory')} icon={<History />} />
        <BottomNavigationAction label="WhatsApp" icon={<WhatsApp />} disabled={!caseData?.clientWhatsappNumber} />
      </BottomNavigation>
    </Box>
  );
};
